import React from "react";

/**
 * Hand-drawn icon set — no icon library. Every glyph is plotted on the same
 * 16-unit grid with square caps and no rounded corners, so they read as drafting
 * marks rather than generic UI icons and sit correctly next to mono labels.
 */
const PATHS = {
  arrowOut: "M5.5 10.5 10.5 5.5M6.75 5.5h3.75v3.75",
  arrowDown: "M8 3.5v9M4.25 8.75 8 12.5l3.75-3.75",
  arrowRight: "M3.5 8h9M8.75 4.25 12.5 8l-3.75 3.75",
  arrowLeft: "M12.5 8h-9M7.25 11.75 3.5 8l3.75-3.75",
  plus: "M8 3.5v9M3.5 8h9",
  minus: "M3.5 8h9",
  close: "M4 4l8 8M12 4l-8 8",
  menu: "M2.5 6h11M2.5 10h11",
  copy: "M5.5 5.5V3h7.5v7.5h-2.5M3 5.5h7.5V13H3z",
  check: "M3.5 8.5 6.5 11.5 12.5 5",
  mail: "M2.5 4.5h11v7h-11zM2.5 4.5 8 9l5.5-4.5",
  dot: "M8 8h.01",
};

const Icon = ({ name, size = 16, className = "", strokeWidth = 1.25 }) => {
  const d = PATHS[name];
  if (!d) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeLinejoin="miter"
      aria-hidden="true"
      focusable="false"
      className={`inline-block shrink-0 ${className}`}
      style={{ verticalAlign: "-0.125em" }}
    >
      <path d={d} />
    </svg>
  );
};

export default Icon;
